import axios from "axios";

export function getPromptPrincipalId(prompt) {
  return String(
    prompt?.principal_id || prompt?.principalId || prompt?.principal?.id || ""
  );
}

export function isTenantPrompt(prompt, principalId) {
  const promptPrincipalId = getPromptPrincipalId(prompt);
  return !!promptPrincipalId && promptPrincipalId === String(principalId);
}

export function isGlobalPrompt(prompt) {
  const promptPrincipalId = getPromptPrincipalId(prompt);
  return !promptPrincipalId || !!prompt?.shared;
}

export function promptSortScore(prompt, principalId) {
  const scopeRank = isTenantPrompt(prompt, principalId)
    ? 0
    : isGlobalPrompt(prompt)
    ? 1
    : 2;
  const defaultRank = prompt?.isDefault ? 0 : 1;
  return scopeRank * 10 + defaultRank;
}

export function dedupePrompts(prompts = []) {
  const byKey = new Map();
  prompts.forEach(prompt => {
    const key =
      prompt?._id ||
      [prompt?.shortId || "", prompt?.name || "", prompt?.action || ""].join(
        ":"
      );
    if (!key || byKey.has(key)) {
      return;
    }
    byKey.set(key, prompt);
  });
  return Array.from(byKey.values());
}

export function orderPromptsByPriority(prompts = [], principalId) {
  return dedupePrompts(prompts).sort(
    (a, b) => promptSortScore(a, principalId) - promptSortScore(b, principalId)
  );
}

export function mapPromptOption(prompt) {
  return {
    id: prompt._id,
    name: prompt.name,
    module: prompt.module,
    action: prompt.action,
    principalId: getPromptPrincipalId(prompt),
    apiShortId: prompt.apiShortId,
    promptShortId: prompt.shortId,
    isDefault: prompt.isDefault,
    shared: !!prompt.shared
  };
}

export async function requestPromptList(
  apiUrl,
  params,
  headers,
  silent = false
) {
  try {
    const res = await axios.get(`${apiUrl}api/eo-prompt/prompts`, {
      params,
      headers
    });
    return Array.isArray(res.data) ? res.data : [];
  } catch (e) {
    if (!silent) {
      console.error("Fehler beim Laden der Prompts:", e);
    }
    return [];
  }
}

export async function fetchPromptCandidatesByAction({
  apiUrl,
  headers,
  principalId,
  module,
  action,
  force = false,
  silent = false
}) {
  const params = {
    principal_id: principalId,
    module,
    force
  };
  if (action) {
    params.action = action;
  }

  const prompts = await requestPromptList(apiUrl, params, headers, silent);
  return orderPromptsByPriority(prompts, principalId);
}
